import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import FilterLink from '../../../components/filter/FilterLink'
import StatusPickerModal from './StatusPickerModal'

const StatusPicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation('common')
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiFlagLine'}
        label={label || t('status')}
        value={compactString(value, { key: 'label', t: t, tField: 'statusIds' })}
        onClick={() => setOpen(true)}
      />
      <StatusPickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default StatusPicker
